import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./CSS/Contact.css";

const Contact = () => {
  return (
    <div className="contact-section">
      <h2 className="contact-title">संपर्क साधा</h2>
      <div className="contact-container">
        {/* Left side - Info */}
        <div className="contact-info">
          <p><FaPhoneAlt className="icon" /> 022 24714144</p>
          {/* <p><FaEnvelope className="icon" /> bhairavnathkridamandalSatara@gmail.com</p> */}
          <p>
            <FaMapMarkerAlt className="icon" />
            भैरवनाथ क्रीडा मंडळ सातारा, पोस्ट सातारा ४१६३१२
          </p>
        </div>

        {/* Right side - Form */}
        <div className="contact-form">
          <form>
            <iframe className="map"
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.0308040765935!2d73.9948671742169!3d17.69600489384311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc239bb7e276c09%3A0x4ca3b232908b0dea!2sShri%20Bhairavnath%20Mandir!5e0!3m2!1sen!2sin!4v1756462722541!5m2!1sen!2sin" 
                  height="200"width="470"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="fast"
                ></iframe>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
